import React from 'react'

const ErrorLogs = (props) => {
    return (
        <div className="connector-meta-col">
            <p className="connector-meta-label">Error Logs</p>
            <div className="connector-meta-value">
                <span>{props.errorCount}</span>
            </div>
        </div>
    )
}

export default ErrorLogs
